import Box from '@mui/material/Box';
import { alpha } from '@mui/material/styles';

import { IMAGE_OVERLAY_Z_INDEX } from '../../config';

export const ImageOverlay = ({ children, lighten }: { children?: React.ReactNode; lighten?: boolean }) => {
  return (
    <Box
      data-testid="image-overlay"
      sx={({ palette }) => ({
        alignItems: 'center',
        background: lighten ? alpha(palette.background.default, 0.5) : null,
        display: 'flex',
        height: '100%',
        justifyContent: 'center',
        pointerEvents: 'none',
        position: 'absolute',
        width: '100%',
        zIndex: IMAGE_OVERLAY_Z_INDEX,
      })}
    >
      {children}
    </Box>
  );
};
